import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Paragraph } from '../models/paragraph';
import { deleteParagraphEndpoint } from './const';

export const deleteParagraph = (paragraph: Paragraph) => {
    paragraph.isDeleted = true;
    return getHttpClient().post({ url: deleteParagraphEndpoint, data: JSON.stringify(paragraph) });
};
